var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor d-flex flex-column justify-content-center align-items-center spinner-container"},[(_vm.title)?_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('img',{staticClass:"loading-search-gif",attrs:{"src":require("@/assets/images/search_oliver.gif"),"alt":"Recherche en cours..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }